import React from 'react';

import { LineChart } from '@magoosh/lib/charts';

import StatisticData from '../statistic_data';

import colors from '@magoosh/lib/styles/colors.module.scss';

interface Props {
  filters: any;
}

const PercentCorrectChart: React.FC<Props> = (props) => {
  const loadingPlaceholder = (
    <div className="d-flex flex-column flex-lg-row gap-s">
    </div>
  );

  if (!props.filters) {
    return loadingPlaceholder;
  } else {
    return (
      <StatisticData
        filters={props.filters}
        formatDataFn={(data) => [{ data, id: 'Estimated Score' }] }
        name="estimated_score"
      >
        <StatisticData.Loading>
          {loadingPlaceholder}
        </StatisticData.Loading>

        {/* @ts-ignore */}
        <LineChart
          chartProps={{ animate: false }}
        />
      </StatisticData>
    );
  }
};

export default PercentCorrectChart;
